import { render } from "./FeShowBaka.vue?vue&type=template&id=0ec98792"
import script from "./FeShowBaka.vue?vue&type=script&lang=js"
export * from "./FeShowBaka.vue?vue&type=script&lang=js"

import "./FeShowBaka.vue?vue&type=style&index=0&id=0ec98792&lang=css"

import exportComponent from "/var/www/html/aims/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__